export const STORE_LINKS = {
  ios: 'https://apps.apple.com/app/id6752858463',
  android: 'https://play.google.com/store/apps/details?id=com.liftpeak.app',
  desktop: 'https://liftpeak.com',
} as const;
